import React from 'react';

import { BREAKPOINTS, Media } from 'modules/common/components/Media';
import { ItemsFilters } from 'modules/catalog/components/ItemsFilters';

import { ItemsGrid } from './ItemsGrid';
import { MarketplaceAPI } from 'revibe-api';

type Props = {
  filters?: MarketplaceAPI.ItemFilters;
  resetToken?: string;
  pageSize?: number;
  onItemsLoaded?: (items: MarketplaceAPI.Item[], itemsCount: number) => void;
  onFiltersApplied?: (filter: MarketplaceAPI.ItemFilters) => void;
  mode?: 'scroll' | 'pages';
  list?: string;
};

export const ItemsGridWithFilters = ({
  filters = {},
  resetToken = '',
  pageSize,
  onItemsLoaded = () => undefined,
  onFiltersApplied = () => undefined,
  list = 'generic',
}: Props) => {
  return (
    <div className="border-y border-black">
      <Media
        at={BREAKPOINTS.MOBILE}
        className="sticky left-0 top-11 z-10 bg-white md:top-12"
      >
        <div className="border-b border-black">
          <ItemsFilters onApply={onFiltersApplied} type="mobile" />
        </div>
      </Media>
      <div className="grid w-full lg:grid-cols-[20%_minmax(0,1fr)]">
        <Media greaterThanOrEqual={BREAKPOINTS.DESKTOP}>
          <div className="sticky top-[48px] h-[calc(100vh_-_48px)] overflow-y-scroll bg-[#f3f3f3] p-4 pb-10">
            <ItemsFilters onApply={onFiltersApplied} type="desktop" />
          </div>
        </Media>
        <div className="border-black pb-10 lg:border-l">
          <ItemsGrid
            mode="pages"
            filters={filters}
            key={resetToken}
            pageSize={pageSize}
            onItemsLoaded={onItemsLoaded}
            onPageChanged={onFiltersApplied}
            list={list}
          />
        </div>
      </div>
    </div>
  );
};
